import { Component,OnInit,OnDestroy,AfterViewInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { NgbModal,NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { takeWhile } from "rxjs/operators";
import { Router,NavigationExtras,ActivatedRoute } from '@angular/router';

import { environment } from "src/environments/environment";

import { FvmsApiAuthService } from "src/app/shared/service/fvms.api.auth.service";
import { FvmsApiNoticeService } from "src/app/shared/service/fvms.api.notice.service";
import { FilterDateTime } from "src/app/shared/filter";

@Component({
  templateUrl: './auth.ext.err.e401.component.html'
  ,providers: [DatePipe,FilterDateTime]
})
export class AuthExtErrE401Component implements OnInit,OnDestroy,AfterViewInit {
    isContinue:boolean = true;
    subtitle: string;
    public envName:string = environment.name;
    
    constructor(
        private modalService: NgbModal
        ,private formBuilder: FormBuilder
        ,private fvmsApiAuthService:FvmsApiAuthService
        ,private router: Router
        ,private fvmsApiNoticeService:FvmsApiNoticeService
        ,private activatedRoute: ActivatedRoute
    ) {
        
    }

    ngOnInit() {
        
    }

    ngOnDestroy() {
        this.isContinue = false;
    }
    
    ngAfterViewInit() {}
}